import { useState } from 'react';
import { categories } from '@/mocks/categories';

export default function CategorySection() {
  const [selectedCategory, setSelectedCategory] = useState('');
  const [showDropdown, setShowDropdown] = useState(false);

  const handleDropdownSelect = (url: string) => {
    window.open(url, '_blank', 'noopener,nofollow');
    setShowDropdown(false);
    setSelectedCategory('');
  };

  return (
    <section id="categories" className="py-16 md:py-24 bg-background-50">
      <div className="w-full max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 text-xs font-medium tracking-widest uppercase rounded-full border border-secondary-300 text-secondary-600 mb-4">
            14 Kategorii
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold font-heading text-foreground-950">
            Wybierz Swoją Kategorię
          </h2>
          <p className="mt-4 text-base text-foreground-600 max-w-[500px] mx-auto">
            Przeglądaj tysiące produktów w naszych spreadsheetach
          </p>
        </div>

        <div className="relative max-w-[480px] mx-auto mb-14">
          <button
            onClick={() => setShowDropdown(!showDropdown)}
            className="w-full flex items-center justify-between px-5 py-4 bg-background-100 border border-background-200 rounded-2xl text-left hover:border-primary-300 transition-all cursor-pointer"
          >
            <span className={selectedCategory ? 'text-foreground-800' : 'text-foreground-400'}>
              {selectedCategory || 'Wybierz kategorię...'}
            </span>
            <i className={`ri-arrow-down-s-line text-foreground-500 transition-transform ${showDropdown ? 'rotate-180' : ''}`}></i>
          </button>
          {showDropdown && (
            <div className="absolute top-full left-0 right-0 mt-2 bg-background-50 border border-background-200 rounded-2xl shadow-lg overflow-hidden z-30 max-h-[320px] overflow-y-auto">
              {categories.map((cat) => (
                <button
                  key={cat.id}
                  onClick={() => {
                    setSelectedCategory(cat.namePl);
                    handleDropdownSelect(cat.url);
                  }}
                  className="w-full flex items-center gap-3 px-5 py-3 text-left hover:bg-background-100 transition-colors cursor-pointer border-b border-background-100 last:border-b-0"
                >
                  <span className="w-8 h-8 flex items-center justify-center text-primary-500">
                    <i className={`${cat.icon} text-lg`}></i>
                  </span>
                  <span className="text-sm text-foreground-800">{cat.namePl}</span>
                  <i className="ri-arrow-right-up-line text-foreground-400 ml-auto text-sm"></i>
                </button>
              ))}
            </div>
          )}
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 md:gap-5">
          {categories.map((cat) => (
            <a
              key={cat.id}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group flex flex-col items-center p-5 md:p-6 bg-background-100 rounded-2xl hover:bg-accent-50 transition-all cursor-pointer"
            >
              <span className="w-12 h-12 flex items-center justify-center bg-background-50 rounded-xl mb-3 group-hover:bg-accent-100 transition-colors">
                <i className={`${cat.icon} text-xl text-primary-500 group-hover:text-primary-600`}></i>
              </span>
              <span className="text-sm font-medium text-foreground-800 text-center leading-tight">
                {cat.namePl}
              </span>
              <span className="mt-2 opacity-0 group-hover:opacity-100 transition-opacity">
                <i className="ri-arrow-right-up-line text-xs text-primary-500"></i>
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}